"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.insuranceRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getInsuranceList: {
        callMethod: 'GET',
        endpoint: '/insurance/list',
    },
    updateMediplusStatus: {
        callMethod: 'POST',
        endpoint: '/insurance/update-mediplus-status',
    },
});
//# sourceMappingURL=insurance.methods.js.map